import logreg from '../js/logreg';
export default {
  name: 'passwordwrap',
  props: {
    mb: {
      type: String,
      default: ''
    },
    log: {
      type: String,
      default: ''
    },
    hide: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      password: '',
      passwordError: '',
      eyeState: false
    };
  },
  components: {},
  methods: {
    passwordInput: function passwordInput() {
      this.passwordCheck();
      this.$emit('changePasswordError', this.passwordError);
      this.$emit('changePassword', this.password);
    },
    passwordBlur: function passwordBlur() {
      this.passwordCheck(true);
      this.$emit('changePasswordError', this.passwordError);
    },
    passwordCheck: function passwordCheck(state) {
      if (!this.password) {
        this.passwordError = this.$t(this.$loginLangPrefix('userSign.webLoginPasswordTips'));
      } else if (logreg.validate(this.password, 'password')) {
        this.passwordError = '';
      } else if (state) {
        this.passwordError = this.$t(this.$loginLangPrefix('userSign.webLoginPasswordTips'));
      }
    },
    changeEye: function changeEye() {
      this.eyeState = !this.eyeState;
    },
    next: function next() {
      this.$emit('btnSure');
    }
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};